module.exports = __webpack_public_path__ + "img/icon.6141864d.png";